interface SentryScope {
  setUser: (user: object) => void;
  setTag: (tagName: string, tagValue: number) => void;
}

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `sentry` namespace.
 */
export const setSentryIdentity = (id: number): void => {
  window.Sentry.configureScope((scope: SentryScope) => scope.setUser({ id }));
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `sentry` namespace.
 */
export const setSentrySiteIdTag = (siteId: number): void => {
  window.Sentry.configureScope((scope: SentryScope) => {
    scope.setTag('site_id', siteId);
  });
};
